export { default, Holds } from './Holds';



// WEBPACK FOOTER //
// ./app/components/borrowing/holds/Holds/index.js